import React, { lazy, memo, Suspense } from 'react';
import { AccessibilityAnchorButtonProps } from './schema/AccessibilityAnchorButtonProps';
import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
import './mutators/index';
import './orchestrators/index';

const LazyAccessibilityAnchorButton = lazy(() => import('./components/AccessibilityAnchorButton'));

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "Accessibility" */ './lazyIndex')
);

// TODO: Remove satchel dependencies for this component
export const AriaLiveWrapper = createLazyComponent(lazyModule, m => m.AriaLiveWrapper);
export const AccessibilityAnchorButton = memo((props: AccessibilityAnchorButtonProps) => (
    <Suspense fallback={null}>
        <LazyAccessibilityAnchorButton {...props} />
    </Suspense>
));

export { default as addAriaLiveLabel } from './actions/addAriaLiveLabel';
export { default as removeAriaLiveLabel } from './actions/removeAriaLiveLabel';
export { default as AriaComponentProps } from './store/schema/AriaComponentProps';
export { default as AriaProps } from './store/schema/AriaProps';
export { default as translateToAriaComponentProps } from './utils/translateToAriaComponentProps';
export { AriaLiveLevel } from './store/schema/AccessibilityStore';
export { getScreenerFriendlyPhoneNumber } from './utils/getScreenerFriendlyPhoneNumber';

export { ComponentClass }; // needed for lazy components
